import React from "react";
import { PageSkeleton, TableSkeleton, PanelSkeleton } from "./common/skeletons";

/**
 * Admin loading placeholder — skeleton UI (not spinner).
 * @param {"page" | "modal" | "table" | "panel"} [variant="page"]
 * @param {number} [rows]
 * @param {number} [cols]
 */
const Loading = ({ variant = "page", rows, cols }) => {
  if (variant === "modal") {
    return (
      <div className="w-full min-h-[200px] p-2" role="status" aria-label="Loading">
        <TableSkeleton rows={rows || 5} cols={cols || 4} />
      </div>
    );
  }
  if (variant === "table") {
    return (
      <div className="w-full" role="status" aria-label="Loading">
        <TableSkeleton rows={rows || 8} cols={cols || 6} />
      </div>
    );
  }
  if (variant === "panel") {
    return <PanelSkeleton />;
  }
  return (
    <div className="w-full min-h-[60vh]" role="status" aria-label="Loading">
      <PageSkeleton />
    </div>
  );
};

export default Loading;
